import React from "react";
import Business from "../../Assets/Business.png";

function Businessbox() {
  return (
    <section className="padding-y bg-gradient-to-r from-gray-800 to-gray-900 text-white mt-10">
      <div className="border rounded-md border-blue-500 bg-[#2B659629] container mx-auto flex flex-col md:flex-row w-full md:w-4/5 lg:w-3/4 h-auto p-5 md:p-8">
        {/* Left Section: Image */}
        <div className="w-full md:w-1/2 flex justify-center mb-8 md:mb-0">
          <img
            src={Business}
            alt="Blockchain Illustration"
            className="w-3/4 md:w-full h-auto"
          />
        </div>

        {/* Right Section: Content */}
        <div className="w-full md:w-1/2 flex flex-col justify-center text-white text-left px-4 md:px-8">
          <h2 className="text-2xl md:text-4xl font-extrabold mb-4">
            Your <span className="text-blue-400">Business</span> Ready For The
            Blockchain
          </h2>
          <p className="text-sm md:text-base text-gray-300 mb-5">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. At sit ut
            nulla eu stetuer eget. Nec, ac sollicitudin aliquam ut egestas duis
            dolor.
          </p>

          {/* Email Form */}
          <div className="flex">
            <input
              type="email"
              placeholder="Your Email address ..."
              className="text-white w-full px-4 py-2 border bg-[#2B659629] border-gray-400 rounded-tl-lg rounded-bl-lg focus:outline-none focus:border-blue-400"
            />
            <button className="h-auto px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-sans rounded-tr-lg rounded-br-lg">
              Join Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Businessbox;
